import { useEffect } from "react";
import { setSEO } from "@/lib/api";

const ITEMS = [
  ["US-Based", "FEMBOT NEX is US-based. All prices in USD."],
  ["Currency", "All prices are in USD."],
  ["Preorders", "Some drops may be preorder-based. Preorder timelines are clearly listed before purchase."],
  ["Ready-to-Ship", "Ready-to-ship items ship faster than preorder pieces."],
  ["Production", "Preorder production typically ships 2–4 weeks after the drop window closes."],
  ["Contraband", "Limited and contraband items may be final sale unless defective."],
  ["Sizing", "Customers should check the size guide before ordering. Final fit notes may update after sample review."],
  ["Defects", "If your item arrives defective, transmit via /contact within 7 days for resolution."],
];

export default function Shipping() {
  useEffect(() => {
    setSEO({
      title: "Shipping & Returns | FEMBOT NEX",
      description:
        "FEMBOT NEX shipping and returns policy. US-based, USD pricing, preorder windows, ready-to-ship details, and final sale notes for contraband.",
    });
  }, []);

  return (
    <div data-testid="shipping-page" className="max-w-[1400px] mx-auto px-4 md:px-8 py-16 md:py-24">
      <div className="section-label">// LOGISTICS</div>
      <h1 className="mt-3 font-display text-5xl md:text-7xl tracking-tight leading-[0.9]">
        Shipping & <span className="text-[#ff1493]">Returns</span>.
      </h1>
      <p className="mt-6 max-w-2xl text-[#a3a3a3] leading-relaxed">
        Transparent. US-domestic. Read the file before authorizing access.
      </p>

      <div className="mt-12 border border-[#262626]">
        {ITEMS.map(([k, v], i) => (
          <div
            key={k}
            className={`grid md:grid-cols-[260px_1fr] gap-0 ${i !== ITEMS.length - 1 ? "border-b border-[#262626]" : ""}`}
          >
            <div className="px-5 py-5 md:py-6 bg-black border-r border-[#262626] font-mono text-[11px] tracking-[0.2em] uppercase text-[#ff1493]">
              // {k}
            </div>
            <div className="px-5 py-5 md:py-6 text-[#e5e5e5] leading-relaxed">{v}</div>
          </div>
        ))}
      </div>

      <div className="mt-10 font-mono text-[11px] tracking-[0.2em] uppercase text-[#6b6b6b]">
        // Policy last updated: SS26 / Transmission 001
      </div>
    </div>
  );
}
